import { Component, ElementRef, ViewChild, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy }  from '@angular/core';

import { FormControl, FormGroup, FormArray } from '@angular/forms';
import {CtlUserForm} from '../user/CtlUserForm';
import {environment} from '../../../../../../src/environments/environment';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-ctl-school-detail',
  templateUrl: './CtlSchoolInfoDetail.html',
  styleUrls: ['./CtlSchoolInfoDetail.css']

})

export class CtlSchoolInfoDetail implements OnInit {

  @Input() myFormGroup: FormGroup;
  @Input() currentstep;
  @Input() projectName;
  @Input() data: any;
  @Input() userData: any;

  @Output() editSchool: EventEmitter<string> = new EventEmitter();
  @Output() editAdmin: EventEmitter<string> = new EventEmitter();

  @ViewChild(CtlUserForm)
  childUser: CtlUserForm;

  loginInfoObj = null;
  isLoggedin = null;

  environment: any;

  constructor() { }

  ngOnInit() {
    this.currentstep = 3;
    this.loginInfoObj = JSON.parse(this.returnLoginInfoObj())
    this.isLoggedin = window.localStorage.getItem('loginInfoObj');
    this.environment = environment;
  }

  editLink() {
    this.editSchool.emit('school');
  }
  editAdminLink() {
    this.editAdmin.emit('admin');
  }
  ngOnDestroy(){

  }
  returnLoginInfoObj() {
    return window.localStorage.getItem('loginInfoObj')
  }
}
